import { getContainer } from '@mews-commander/legacy-app-instance';
import { WallClockDateService } from '@mews/framework';

/** @deprecated DateTimeUtils.dateIsoStringToDateString */
export const localizeWallClockDateString = (dateString: $TSFixMe) => {
    const container = getContainer();
    const { appLocalizationComponent } = container();

    return dateString
        ? appLocalizationComponent.localizeWallClockDate(WallClockDateService.parse(dateString))
        : undefined;
};

/** @deprecated use WallClockDateService.fromString */
export const getWallClockDateUtcString = (wallClockString: $TSFixMe) => {
    const container = getContainer();
    const { appLocalizationComponent } = container();

    if (!wallClockString) {
        return;
    }

    const { value } = appLocalizationComponent.parseWallClockDate(wallClockString);
    return value;
};
